import { Flex, Stack, Text } from '@chakra-ui/react'
import { ReactNode } from 'react'
import { Modal } from 'ui/src/components/modal'
import { H3 } from 'ui/src/components/typography/Headings'
import { BoldText, MediumBoldText } from 'ui/src/components/typography/Paragraph'

interface CourseOptionDetailProps {
  detailHeading: string
  detail?: string | undefined
}

export const CourseOptionDetail = ({ detailHeading, detail }: CourseOptionDetailProps) => (
  <Flex flexDirection={{ base: 'row', lg: 'column' }}>
    <BoldText mb={0} mr={{ base: '10px', lg: 'unset' }} minW="120px">
      {detailHeading}
    </BoldText>
    <Text mb={0}>{detail}</Text>
  </Flex>
)

interface CourseOptionsModalProps {
  children?: ReactNode
  isOpen: boolean
  onClose: () => void
  courseName: string
  courseLevel: string
}

export const CourseOptionsModal = ({
  children,
  isOpen,
  onClose,
  courseName,
  courseLevel,
}: CourseOptionsModalProps) => {
  return (
    <Modal isOpen={isOpen} size="full" onClose={onClose}>
      <Modal.Overlay />
      <Modal.Content
        position="relative"
        maxWidth={{ lg: '650px' }}
        minHeight={{ base: 'full', lg: 'unset' }}
        borderRadius={{ base: 0, lg: '20px' }}
      >
        <Modal.Body
          px={{ base: '25px', lg: '30px' }}
          pt={{ base: 20, lg: 10 }}
          pb={{ base: '72px', lg: '60px' }}
        >
          <Stack spacing={3} mb={5} pr={12}>
            <H3 mb={0}>{courseName}</H3>
            <MediumBoldText fontSize="18px" letterSpacing="-1px">
              {courseLevel}
            </MediumBoldText>
          </Stack>
          <Text mb={0}>
            This course has multiple options, meaning you can study at different times or campuses.
            See the details below to see when and where this course is on offer.
          </Text>
          <MediumBoldText fontSize="18px" letterSpacing="-1px" mt={10} mb={0}>
            Course options:
          </MediumBoldText>
          {children}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  )
}
